import './CourseItem.css'
import { FaUsers } from "react-icons/fa";
import { GiTeacher } from "react-icons/gi";
import { BiDollar } from "react-icons/bi";

function CourseItem({image , studentCount , title , description , teacher , mainPrice}) {
    return (
        <div className="courseCardWrapper">

            <div className="courseCardImage">
                <img className='courseImage' src={image} alt="courseImage" />
                {/* this p below for student count section */}
                <p>
                    <FaUsers size='20px' />
                    <span>{studentCount}</span>
                </p>
            </div>

            <div className="courseCardContent">
                <h5 className='courseName'>{title}</h5>
                <p className='courseDescription'>{description}</p>
            </div>

            <div className="courseCardTeacher">
                <p>
                    <GiTeacher size='25px' />
                    Teacher : {teacher}
                </p>
            </div>

            <div className="courseCardFooter">
                <p>
                    <button> <b>Course Registration</b> </button>
                </p>

                <p>
                    <BiDollar size='25px' />
                    <b>{mainPrice}</b>
                </p>
            </div>
        </div>
    )
}

export default CourseItem